import { render, staticRenderFns } from "./dropzone-single.vue?vue&type=template&id=90cd7758&"
import script from "./dropzone-single.vue?vue&type=script&lang=js&"
export * from "./dropzone-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports